'use client';
import PaymentGuardianIcon from '@/components/customercenter-ui/svgs/paymentGuardian';
import { PaymentGuardianData } from '../../customer-detail/types';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import AddPaymentGuardianModal from '../customerDetailAction/addPaymentGuardian';

const PaymentGuardianLearnMoreModal = ({
  Texts,
  paymentGuardianData,
  setData,
  open,
  setOpen,
}: {
  Texts: any;
  paymentGuardianData: PaymentGuardianData;
  setData: any;
  open: any;
  setOpen: any;
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
      }}
    >
      <DialogContent className="max-w-[466px] bg-white sm:rounded-md">
        <DialogHeader>
          {/* chng-text-25px */}
          <DialogTitle className="flex justify-center text-2xl font-bold">
            <PaymentGuardianIcon />
          </DialogTitle>
        </DialogHeader>
        <section className="my-4 max-h-[360px] overflow-y-auto px-2 text-center">
          <p>{paymentGuardianData?.learnMore}</p>
        </section>
        <section className="mt-4 flex justify-center gap-4">
          <AddPaymentGuardianModal
            setModalOpen={setOpen}
            Texts={Texts}
            paymentGuardianData={paymentGuardianData}
            setData={setData}
          />
          <Button className="p-0 underline" onClick={() => setOpen(false)}>
            {Texts.cancelButton}
          </Button>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentGuardianLearnMoreModal;
